import React from 'react';
import { DatePicker, Form, Row } from 'antd';
import { Col, FilterDrawer, FormInstance, Select } from 'components';
import { CalendarIcon } from 'components/common/icons';
import { useFilters } from './useFilter';
import { useSelectedBrandsBySupplierIdQuery } from 'api';
import { useParams } from 'react-router-dom';

interface IFilters {
  form: FormInstance;
  drawerOpen: boolean;
  closeDrawer: () => void;
  applyFilters: (value: Record<string, any>) => void;
  resetFilters: () => void;
}

export const Filter = React.memo((props: IFilters) => {
  const { form, drawerOpen, closeDrawer, applyFilters, resetFilters } = props;
  const { id } = useParams() as { id: string };
  const { data = [] } = useSelectedBrandsBySupplierIdQuery({ supplierId: id });
  const { clearFilters } = useFilters({ form, resetFilters });
  return (
    <FilterDrawer
      title="Filter"
      placement="left"
      width={471}
      styles={{
        body: {
          marginBottom: 80,
        },
      }} // Add space for drawer actions
      onClose={closeDrawer}
      open={drawerOpen}
      onApply={() => form.submit()}
      onClear={clearFilters}
      onExpand={closeDrawer}
    >
      <Form layout="vertical" form={form} onFinish={applyFilters}>
        <Row gutter={[0, 16]}>
          <Col span={24}>
            <Form.Item label={'Brand'} name={'brandId'}>
              <Select size={'middle'} options={data} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label={'Created Date'} name={'createdDate'}>
              <DatePicker.RangePicker size={'middle'} style={{ width: '100%' }} suffixIcon={<CalendarIcon />} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label={'Expiry Date'} name={'expireDate'}>
              <DatePicker.RangePicker size={'middle'} style={{ width: '100%' }} suffixIcon={<CalendarIcon />} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </FilterDrawer>
  );
});
